import styled from "styled-components";

const KycFailWrapper = styled.div`
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	align-self: stretch;
	padding: 40px;
	gap: 32px;
	border-radius: 12px;
	background: var(--White, #FFF);
	box-shadow: 0px 4px 10px 0px rgba(9, 30, 66, 0.00);
	width: 60%;
	margin: 4rem auto;
	border: 1px solid #eee;
	@media screen and (max-width: 875px) {
		width: 85%;
	}

	.kyc-head {
    color: var(--text-black,#1A1C1F);
    font-size: 2rem;
    font-weight: 700;
    line-height: 120%;
    -webkit-letter-spacing: -0.84px;
    -moz-letter-spacing: -0.84px;
    -ms-letter-spacing: -0.84px;
    letter-spacing: -0.84px;
    width: 64%;
    text-align: start;
		@media screen and (max-width: 875px) {
			font-size: 1.3rem;
			width:100%;
		}
	}
	.supp-content{
		text-align:start;
		cursor:pointer;
	}
	.kyc-paragraph {
		color: var(--text-dark-gray, #455560);
		font-size: 1rem;
		font-weight: 400;
		line-height: 160%;

		@media screen and (max-width: 768px) {
			font-size: 0.9rem;
			width:100%;
			text-align: start;
		}
	}

	.contact-services {
		display: flex;
		padding: 24px;
		align-items: flex-start;
		gap: 24px;
		align-self: stretch;
		border-radius: 8px;
		background: var(--neutral-light, #F2F3F5);
		flex-wrap: wrap;

		@media screen and (max-width: 768px) {
			padding: 16px;
		}
	}

	.serv-box {
		display: flex;
		gap: 1rem;
	}

	.vertical-line {
		width: 2px;
		opacity: 0.1;
		background: var(--text-black, #1A1C1F);
		height: 44px;

		@media screen and (max-width: 768px) {
			height: 36px;
		}
	}

	.btn-back {
		display: flex;
		align-items: center;
		display: flex;
		height: 54px;
		padding: 0px 24px 0px 16px;
		justify-content: center;
		align-items: center;
		gap: 8px;
		border-radius: 8px;
		background: var(--primary-primary-color, #6B47F5);
		color: var(--others-white-button, #FFF);
		font-size: 16px;
		font-weight: 400;
		line-height: 16px;
		border: 0;

		@media screen and (max-width: 768px) {
			height: 48px;
			font-size: 14px;
		}
	}
`;

export default KycFailWrapper;
